/**
 * @voltxampere/ui — WireCommand (Sprint 13)
 *
 * Append one or more `Wire` records to a circuit (Manhattan paths
 * may produce 1-2 segments — each segment is a separate `Wire`
 * record on the same `netId`, per Sprint 13's schema-immutability
 * discipline). The constructor takes the full segment list so
 * `undo` removes exactly the same set of ids.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
export class WireCommand {
    wires;
    ids;
    constructor(wires) {
        this.wires = wires;
        this.ids = new Set(wires.map((w) => w.id));
    }
    do(circuit) {
        return { ...circuit, wires: [...circuit.wires, ...this.wires] };
    }
    undo(circuit) {
        return {
            ...circuit,
            wires: circuit.wires.filter((w) => !this.ids.has(w.id)),
        };
    }
    describe() {
        return this.wires.length === 1
            ? "Wire eklendi"
            : `${String(this.wires.length)} segment eklendi`;
    }
}
//# sourceMappingURL=wire.js.map